import { c as _c } from "react/compiler-runtime";
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
export type AccordionProps = StructuredContentDocumentWithRenderer<{
  children: StructuredContentDocument;
}>;
export const Accordion = t0 => {
  const $ = _c(4);
  const {
    props: t1
  } = t0;
  const {
    children
  } = t1;
  let t2;
  if ($[0] !== children) {
    t2 = renderStructuredContent(children);
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <>{t2}</>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};